module.exports = __webpack_public_path__ + "img/img-7.4e00e9ca.webp";